export const KEYWORD_SEARCH_PLACEHOLDER = 'Search makes, models, body...';
